import { Component, type ErrorInfo, type ReactNode } from 'react';
import { recordDevToolsLog } from '../lib/devToolsLogger';

type Props = { children: ReactNode };
type State = { hasError: boolean };

/** Captures React render errors and forwards them to DevTools (when enabled). */
export class DevToolsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    recordDevToolsLog({
      level: 'error',
      origin: 'react',
      message: error.message,
      stack: `${error.stack ?? ''}\nComponent stack:${info.componentStack ?? ''}`,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="admin-shell">
          <div className="panel" style={{ maxWidth: 440, width: '100%' }}>
            <div className="state-block">
              <div className="state-block__icon state-block__icon--danger" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 8v5" />
                  <path d="M12 16h.01" />
                </svg>
              </div>
              <h2 className="state-block__title">Coś poszło nie tak</h2>
              <p className="state-block__desc">
                Wystąpił nieoczekiwany błąd. Został zarejestrowany - odśwież stronę i spróbuj ponownie.
              </p>
              <button type="button" className="btn-secondary" onClick={() => window.location.reload()}>
                Odśwież stronę
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
